import { render, staticRenderFns } from "./pztk.vue?vue&type=template&id=ea3fa05c&scoped=true&"
import script from "./pztk.vue?vue&type=script&lang=js&"
export * from "./pztk.vue?vue&type=script&lang=js&"
import style0 from "./pztk.vue?vue&type=style&index=0&id=ea3fa05c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3fa05c",
  null
  
)

export default component.exports